import {
  ConfigWrapper,
  DesktopLayoutBoxed,
} from '@kanda-libs/ks-design-library';

import { CardPaymentForm, Copyright, JobSidebar } from 'components';
import CardContent from 'components/CardContent';
import useHelpModal from 'components/HelpModal/useHelpModal';

import { PayByCardPropsHook } from '../usePayByCardProps';

const Desktop: React.FunctionComponent<PayByCardPropsHook> = function (props) {
  const { showHelpModal } = useHelpModal();
  return (
    <ConfigWrapper sidebar={JobSidebar}>
      <DesktopLayoutBoxed
        help={showHelpModal}
        backgroundLines
        sidebar
        options={[]}
        layoutFooter={<Copyright />}
      >
        <CardContent>
          <CardPaymentForm
            {...props}
            title="Enter card details below"
            buttonLabel="Pay for job"
          />
        </CardContent>
      </DesktopLayoutBoxed>
    </ConfigWrapper>
  );
};

export default Desktop;
